<template>
  <div  :class="getSearchStyles" @keyup.13.prevent="filter">
    <!--    <search-categories @change="onChange" />-->
    <div class="columns is-multiline  is-desktop is-mobile padding-x">
      <column size="is-12-mobile is-12-tablet is-3-desktop">
        <div class="is-grouped">
          <p class="control is-expanded has-icons-left">
            <input v-model="keyword" class="input" type="search" :placeholder="this.$t('widget.keyword')">
            <span class="icon is-small is-left">
                <i class="fas fa-search"></i>
              </span>
          </p>

        </div>
      </column>
      <column size="is-half-mobile is-6-tablet is-3-desktop">
        <div class="is-grouped">
          <p class="control is-expanded has-icons-left">
            <input v-model="locations" class="input" type="search" :placeholder="this.$t('widget.location')">
            <span class="icon is-small is-left">
            <i class="fas fa-map-marker-alt"></i>
          </span>
          </p>
        </div>
      </column>
      <column  size="is-half-mobile is-6-tablet is-3-desktop">
        <div class="mt-2">
          <jobseeker-autocomplete-filter :options="jobBoardsList" :label="this.$t('jobs.allEco')" :placeHolder="this.$t('jobs.allEco')" v-model="formSelectedJobBoards"></jobseeker-autocomplete-filter>
        </div>
      </column>

      <column  size="is-half-mobile is-6-tablet is-3-desktop ">
        <div class="is-grouped">
          <div class="control is-expanded">
            <div class="width-100 select">
              <select class="width-100" v-model="jobType" @change.prevent="filter">
                <option value="">{{this.$t('widget.allEmploymentTypes')}}</option>
                <option v-for="type in jobTypes" :value="type.name" :key="type.id">{{type.name}}</option>
              </select>
            </div>
          </div>
        </div>
      </column>

      <column v-if="getWidth === 'xs'"  size="is-12-mobile is-12-tablet is-4-desktop is-one-fifth-widescreen is-one-fifth-fullhd">
        <button class="is-primary button is-fullwidth" @click="filter">{{this.$t('widget.search')}}</button>
      </column>
    </div>
  </div>
</template>

<script>
import {mapActions, mapState, mapMutations} from 'vuex'

import SearchCategories from '../jobs/search/categories'
import Column from '../general/column'
import JobseekerAutocompleteFilter from './jobseeker-autocomplete-filter'
import {jobCategoryOptionsEs, jobCategoryOptions} from '../../constants/array-constants'
import {MUNDO_CRYPTO} from '../../constants/jobboards-ids'

export default {
  name: 'JobSeekerFilters',
  data () {
    return {
      salaryRanges: [{'label': 'Negotiable', value: 'negotiable'}, {'label': '$50k - $100k', 'value': '50000,100000'}, {'label': '$100k - $200k', 'value': '100000,200000'}],
      keyword: '',
      locations: '',
      jobType: '',
      salaryRange: '',
      jobCategory: '--all--',
      ecoSystem: '',
      windowWidth: 0,
      selectedJobBoards: []
    }
  },
  components: {SearchCategories, Column, JobseekerAutocompleteFilter},
  computed: {
    ...mapState('domain', ['jobTypes']),
    ...mapState('jobs', ['jobBoardsList']),
    q () {
      const q = this.$route.meta.stacks ? 'stacks' : null
      return this.$route.query.q || q
    },
    getWidth () {
      if (this.windowWidth <= 1050) {
        return 'xs'
      }
      return 'lg'
    },
    jobCategories () {
      return this.$i18n.locale === 'es' ? jobCategoryOptionsEs : jobCategoryOptions
    },
    getSearchStyles () {
      const url = this.$route.fullPath
      return url.split('/')[url.split('/').length - 1] === MUNDO_CRYPTO ? 'search-bar mun-dark' : 'search-bar mundo-dark'
    },
    formSelectedJobBoards: {
      get () { return this.selectedJobBoards },
      set (value) {
        this.selectedJobBoards = value
        this.filter()
      }
    }
  },
  methods: {
    ...mapActions('widget', ['search']),
    ...mapActions('domain', ['fetchJobTypes']),
    ...mapMutations('widget', ['setFilters']),
    ...mapActions('jobseekers', ['getFilterJobSeekers']),
    onChange (jobCategory) {
      this.jobCategory = jobCategory
      this.filter()
    },
    async filter () {
      this.getFilterJobSeekers({data: this.selectedJobBoards,
        keyword: this.keyword ? this.keyword.trim() : '',
        location: this.locations ? this.locations.trim() : '',
        contractTypes: this.jobType ? [this.jobType.toLowerCase()] : []})
    }
  },
  watch: {
    keyword (newValue) {
      if (newValue.trim() === '') {
        this.filter()
      }
    },
    locations (newValue) {
      if (newValue.trim() === '') {
        this.filter()
      }
    }
  },
  mounted () {
    this.keyword = this.q
    this.fetchJobTypes()
    this.windowWidth = window.innerWidth
    window.addEventListener('resize', () => {
      this.windowWidth = window.innerWidth
    })
  }
}
</script>

<style lang="scss" scoped>
.search-bar {
  background: #fff;
  width: 100%;
  padding: 14px 0 16px 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  border-radius: 16px 16px 0px 0px;

  .filter-wpr {
    display: flex;
    flex-direction: row;
    justify-content: center;
    margin: 0 auto;
    width: 80%;
    .field {
      width: 25%;
      .select {
        width: 100%;
        select {
          width: 100%;
        }
      }
    }
    .field:not(:last-child) {
      margin-right: 24px;
      margin-bottom: 0;
    }

    .control.has-icons-left .icon, .control.has-icons-right .icon {
      height: 40px;
      width: 2.75em;
    }

    .control.has-icons-left .input:focus ~ .icon, .control.has-icons-left .select:focus ~ .icon, .control.has-icons-right .input:focus ~ .icon, .control.has-icons-right .select:focus ~ .icon {
      color: #111;
    }
    .control {
      margin-top: 0;
    }
  }
  .width-100{
    width: 100%;
  }
  .padding-x{
    padding-left: 30px;
    padding-right: 36px;
  }
  .mt-4{
    margin-top: 4px
  }
  .mt-2{
    margin-top: 5px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/jobseekers/jobseeker-filters.vue